/* unplugin-vue-components disabled */import script from "./PartnershipInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./PartnershipInfo.vue?vue&type=script&setup=true&lang=js"

import "./PartnershipInfo.vue?vue&type=style&index=0&id=46483dab&lang=css"

const __exports__ = script;

export default __exports__